module.exports = __webpack_public_path__ + "img/single-bet-btn-active.e667dad6.svg";